import React from 'react';
import { motion } from 'framer-motion';

function Footer({ variant = 'default' }) {
  const isDark = variant === 'dark' || variant === 'game';
  
  return (
    <motion.footer
      className={`mt-auto py-6 border-t backdrop-blur-sm ${
        isDark 
          ? 'border-white/20 bg-transparent' 
          : 'border-gray-200 bg-white/50'
      }`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5 }}
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <motion.p
            className={`text-sm ${
              isDark ? 'text-white/80' : 'text-gray-600'
            }`}
            whileHover={{ scale: 1.05 }}
          >
            Made with{' '}
            <motion.span
              className="inline-block text-red-500"
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ duration: 1, repeat: Infinity, repeatDelay: 1 }}
            >
              ❤️
            </motion.span>
            {' '}by{' '}
            <span className={`font-semibold ${
              isDark ? 'text-purple-300' : 'text-purple-600'
            }`}>
              Yash Jha
            </span>
          </motion.p>
          
          <motion.a
            href="https://www.linkedin.com/in/yashjha024/"
            target="_blank"
            rel="noopener noreferrer"
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all backdrop-blur-sm ${
              isDark
                ? 'bg-white/10 hover:bg-white/20 text-white border border-white/20 hover:border-white/40'
                : 'bg-blue-50 hover:bg-blue-100 text-blue-700 border border-blue-200 hover:border-blue-300'
            }`}
            whileHover={{ scale: 1.05, y: -2 }}
            whileTap={{ scale: 0.95 }}
          >
            <svg
              className="w-5 h-5"
              fill="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
            <span className="font-medium">Connect on LinkedIn</span>
          </motion.a>
        </div>
        
        <motion.div
          className={`mt-4 text-center text-xs ${
            isDark ? 'text-white/60' : 'text-gray-500'
          }`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
        >
          © {new Date().getFullYear()} CryptGame. All rights reserved.
          <br />
          <span className="text-xs opacity-75 mt-1 block">
            Built with React, Express.js, and Framer Motion
          </span>
        </motion.div>
      </div>
    </motion.footer>
  );
}

export default Footer;

